export enum PageRoutes {
  Home = "/",
  LoginQR = "/login-qr",
  Game = "/game",
  Explore = "/explore",
  Search = "/search",
  MyGames = "/my-games",
  Settings = "/settings",
  General = "/settings/general",
  ProfileInfo = "/settings/account-info",
  Subscription = "/settings/subscription",
  Exit = "/settings/exit",
  Activate = "/activate",
  Paywall = "/subscribe",
  Payment = "/payment",
  EssentialPass = "/essential-pass",
  InstallGame = "/install-game",
  GamePlay = "/play",
  Landing = "/landing",
  Onboarding = "/onboarding",
  SetProfile = "/set-profile",
  Faq = "/faq",
  Privacy = "/privacy-policy",
  LegalInformation = "/legal-information",
  OpenSource = "/open-source",
  Tnc = "/tnc",
  Support = "/support",
  Tv = "/tv",
  ErrorNetwork = "/error-network",
}
